export default [
    {
        institution: "Western University (UWO)",
        institutionIMG: "img/organizations_logos/western.png",
        site: "https://uwo.ca",
        location: "London, Ontario",
        degree: "Bachelor of Engineering Science (BESc)",
        specialization: "Software Engineering",
        duration: "September 2017 &#8211 April 2021",
        scholarships: ["Western Scholarship of Distinction", "Dean's Honor List (2020-2021)"],
        facultyIMG: "img/organizations_logos/Western_Logo_H_Engineering_RGB_SIM.svg" 
    }
]